<template>
    <pg-page title="Private Gym - Betaling Status"
             header="Bevestiging van de betaling"
             header_tag="h2"
             id="payment-single"
             :footer="false"
    >

        <div class="mx-auto mt-4">
            <form novalidate>
                <div class="row g-3 justify-content-center">
                    <div class="col-sm-6 text-center">
                        <div class="card mb-2 rounded-3 shadow-sm">
                            <div class="card-body my-3">
                                <div v-bind:class="{
                                    'circle-loader': true,
                                    'load-complete': true,
                                    'checkmark': true,
                                }">
                                    <div class="checkmark draw" v-show="true"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

    </pg-page>
</template>

<script>

import PgPage from "../../../Components/PgPage";
import ContactModal from "../../../Components/Contact/ContactModal";
import axios from "axios";

export default {
    components: {ContactModal, PgPage},

    props: {
        attached: {default: false}, // we use this one for a slightly different version of the success page
    },

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
<style lang="scss">
#lid-worden label {
    font-weight: bold;
    color: red;
}
</style>
